import { ca } from '@cian/analytics';

export function trackInfoExpand() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click_sopr',
    label: 'RosreestrInfo',
    useLastProducts: true,
  });
}

export function trackRosreestrInfoShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Show_sopr',
    label: 'RosreestrInfo',
    useLastProducts: true,
  });
}

export const trackCadastralMapView = () => {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'CadastralMap',
    name: 'oldevent',
    useLastProducts: true,
  });
};

export const trackCadastralMapPreviewClick = () => {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CadastralMap',
    name: 'oldevent',
    useLastProducts: true,
  });
};
